export default __webpack_public_path__ + "static/media/Trail.0234ca3c.svg";